'use strict';
angular.module('dashboard.tachoDownloadDashboard', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('tachoDownloadStatusWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.tachoDownloadStatus.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.tachoDownloadStatus.description';
          }
        },
        controller: 'tachoDownloadStatusCtrl',
        templateUrl: 'components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          vehicleGroup: null,
          noOfGridRows: ''
        },
        edit: {
          templateUrl: 'components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidgetEdit.tpl.html',
          reload: false,
          controller: 'tachoDownloadStatusEditCtrl'
        }
      });

  }).service('tachoDownloadStatusService', function (crudService) {

    this.getTachoDataDownloadList = function (vechileGroup) {
      var requestParam = {
        dataRefresh: true,
        reportName: 'TachoDownloadStatus',
        vehicleGroup: vechileGroup,
        timeTo: '-0d'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('tachodownloaddashboard', 'tachodownloadstatus', param);
    };


  }).controller('tachoDownloadStatusCtrl', function ($scope, config, commonTrackService, widgetSettingsCreatorService, vehicleListWidgetService,
    tachoDownloadStatusService, $translate, errorHandlingService, $state, $interval, $rootScope, stateManagerService) {

    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.isReady = false;
    $scope.datePicker = widgetSettingsCreatorService.createDatePickerInstance('dd.MM.yyyy');
    $scope.dateFilter = {
      date: new Date()
    };
    var rowSize = vehicleListWidgetService.getRowSize();


    $scope.customGridProperties = {
      tachoDownloadStatus: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
        pageable: false,
        columns: []
      }
    };
    var tachoDownloadCtxInitialized = false;
    var counterSeconds = 60;
    var counterTimeout;
    $scope.uuidForElement = $scope.$id;
    var tachoDownloadStatusListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };
    var contextMenu = {};
    var broadcastEventData = {
      selectedRow: {},
      selectedVehicleGroup: '',
      selectedStatusCode: '',
      selectedVehicleGroupLabel: '',
      eventSource: '',
      selectedOrderRow: {},
      isRefreshStarted: false,
      lastTabName: '',
      dashboardName: 'dashboard.tachoDownloadStatusList',
      isDataFromTab: true
    };

    function showDashboard() {
      $state.go('betotrack.dashboard');
    }

    function showDriverDashboard() {
      $state.go('driverdashboard');
    }

    function showFmsDashboard() {
      $state.go('fmsdashboard');
    }

    var _contextSourceObj = {
      tachoDownloadStatusCtxSource: [

        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
          execute: showDashboard
        }, {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
          execute: showDriverDashboard
        }, {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
          execute: showFmsDashboard
        }
      ]
    };
    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(100);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      source: _contextSourceObj.tachoDownloadStatusCtxSource, popupZIndex: 999999
    });
    $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
    });

    var loadTachoDownloadStatusList = function (vechileGroup, isDataRefresh) {
      $scope.stop();
      return tachoDownloadStatusService.getTachoDataDownloadList(vechileGroup).then(function (downloadStatusList) {
        if (downloadStatusList) {

          if (isDataRefresh) {
            $scope.customGridProperties.tachoDownloadStatus.columns = commonTrackService.getColumnProperties(downloadStatusList.gridSettings.overviewListGrids[0].columnProperties, downloadStatusList.columnTranslation, { moduleName: 'tachoDownloadStatus' });
            tachoDownloadStatusListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'tachoDownloadStatusList', tachoDownloadStatusListSource);
            tachoDownloadStatusListSource.localdata = downloadStatusList.dataList;


            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.lastLocation') };
            $scope.tachoDownloadStatusSettings = commonTrackService.getGridSettings('tachoDownloadStatus', $scope.customGridProperties.tachoDownloadStatus, null, _additionalProperties);
            $scope.tachoDownloadStatusListAdapter = new window.$.jqx.dataAdapter(tachoDownloadStatusListSource);
            $scope.tachoDownloadStatusSettings.source = $scope.tachoDownloadStatusListAdapter;

            $scope.isDataAvailable = true;
          } else {
            tachoDownloadStatusListSource.localdata = downloadStatusList.dataList;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoDownloadStatusList');
          }

        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {

        $scope.counter = counterSeconds;
        if (($scope.isDataAvailable && !counterTimeout) || (counterTimeout && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled' && $scope.isDataAvailable)) {
          $scope.startCounter();
        } else {
          $scope.stop();
        }
        $scope.dataLoadingFinished = true;
        $scope.createTachoDownloadStatusGrid = true;
      });
    };

    $scope.stopAutoRefresh = function (event, type) {
      if (event) {
        commonTrackService.getRefreshStartStopfunction($scope, true, false, loadTachoDownloadStatusList, 'vehicleGroupComboBox', false, true, event)();
      } else {
        if (type === 'start') {
          $scope.isTimerStated = false;
        } else {
          $scope.isTimerStated = true;
        }
        commonTrackService.getRefreshStartStopfunction($scope, true, false, loadTachoDownloadStatusList, 'vehicleGroupComboBox', false, true)();
      }
    };

    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
        if (vechileGroupList.length > 0) {
          $scope.vehicleGroupSettings.source = vechileGroupList;
          var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) { // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = config.vehicleGroup;
          }

          if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
            if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {// validate the local storage group is still valid ( group can change based on login )
              $scope.vehicleGroup = cachedGroup;
              config.vehicleGroup = cachedGroup;
            }
          }

          if (!$scope.vehicleGroup) {
            $scope.vehicleGroup = vechileGroupList[0].groupID;
          }

        }
      });
    };
    loadVehicleGroup().finally(function () {

      if ($scope.vehicleGroup) {
        loadTachoDownloadStatusList($scope.vehicleGroup, true);
      }

    });


    $scope.gridRowClickHandler = function (event) {
      if (event.args.rightclick) {
        if (!tachoDownloadCtxInitialized) {
          contextMenu = $('#' + $scope.uuidForElement + '_betoTrack_tachoDownloadCtx').jqxMenu($scope.ctxMenuSettings);
          $('#' + $scope.uuidForElement + '_betoTrack_tachoDownloadCtx').on('itemclick', tachoDownloadContextHandler);
          tachoDownloadCtxInitialized = true;
        }
        commonTrackService.initGridRightClickContextMenu(event, contextMenu);
      }
    };
    function tachoDownloadContextHandler(event) {
      commonTrackService.executeContextMenuClick(event, 'tachoDownloadStatusCtxSource', _contextSourceObj);
    }

    $scope.stop = function () {
      $interval.cancel(counterTimeout);
    };

    $scope.startCounter = function () {
      $scope.stop();
      $scope.isTimerStated = true;
      $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
      if ($scope.counter - 1 >= 1) {
        $scope.counter--;
        counterTimeout = $interval($scope.startCounter, 1000);
      } else {
        loadTachoDownloadStatusList($scope.vehicleGroup, true);
      }

    };


    var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
      $rootScope.$broadcast('vehicleMap_res_current_context', {
        dashboardName: 'dashboard.tachoDownloadStatusList',
        isDataFromTab: false,
        tabNumber: 0,
        currentWidgetContextData: broadcastEventData,
        dataLoadingFinished: $scope.dataLoadingFinished,
        isDataAvailable: $scope.isDataAvailable
      });
    });

    // stateManagerService
    // Used when unkown dependant (child) widget requests data.
    // Since this is a global request for data, widget needs to check if the,
    // requested fields is anything it can provide before updating.
    // Will call the dataStateUpdate event if it updates data.
    var updateRequest = $scope.$on('reqDataUpdate', function () {
      var selectedRowData = {};
      var selectIndex = -1;
      if ($('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').length > 0) {
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').jqxGrid('getrowdata', selectIndex);
          stateManagerService.updateValue('tachoDownloadStatusWidget', 'tab_' + 0 + '_selectedRow', selectedRowData, true);
        }
      }
      $rootScope.$broadcast('resDataUpdate',
      {
        widget: 'tachoDownloadStatusWidget',
        activeTab: 0,
        dashboardName: 'dashboard.tachoDownloadStatusList',
        timespan: new Date().getTime()
      });


    });
    $scope.rowSelectHandler = function (event) {
      if (event.type === 'rowselect' && event.args.row) {

        broadcastEventData.gridName = 'tachoDownloadStatus';
        broadcastEventData.selectedRow = event.args.row;
        broadcastEventData.updateWidgetTitle = true;
        broadcastEventData.repoVehicle = event.args.row.deviceid;

        if(event.args.row.tacholasteventtimestamp && (event.args.row.tacholasteventtimestamp !== '')){
          var lastEventMoment = moment(event.args.row.tacholasteventtimestamp*1000);
          broadcastEventData.startDate = lastEventMoment.format('YYYY/MM/DD/HH:mm:ss');
          broadcastEventData.endDate = lastEventMoment.format('YYYY/MM/DD/HH:mm:ss');
        } else {
          broadcastEventData.startDate = '';
          broadcastEventData.endDate = '';
        }
        broadcastEventData.deviceId = event.args.row.deviceid;
        broadcastEventData.dashboardName = 'dashboard.tachoDownloadStatusList';
        broadcastEventData.isDataFromTab = false;
        broadcastEventData.tabNumber = 0;
        broadcastEventData.updateMapUrl = false;
        broadcastEventData.showPushpins = true;

        $rootScope.$broadcast('rowSelected', broadcastEventData);
        $rootScope.$broadcast('eventReportMapUpdate', broadcastEventData);

        stateManagerService.updateValue('tachoDownloadStatusWidget', 'tab_' + 0 + '_selectedRow', broadcastEventData.selectedRow, true);

        $rootScope.$broadcast('dataStateUpdate',
          {
            widget: 'tachoDownloadStatusWidget',
            activeTab: 0,
            dashboardName: 'dashboard.tachoDownloadStatusList',
          });

      }
    };
    $scope.vehicleGroupComboChange = function (event) {
      var vehicleGroup = event.args.item;
      // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
      if (config.vehicleGroup !== vehicleGroup.value) {
        if ($scope.tachoDownloadStatusSettings) {
          loadTachoDownloadStatusList(vehicleGroup.value, $scope.tachoDownloadStatusSettings.columns.length > 0 ? false : true);
        }
      }
      if (vehicleGroup) {
        broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
        broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
        config.vehicleGroup = vehicleGroup.value;

        broadcastEventData.dashboardName ='dashboard.tachoDownloadStatusList';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = 0;
        $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
      }
    };

    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    // Google maps takes focus if the auto refresh enabled
    // Auto refresh must be stoped if the chat window is open to solve focus switching
    var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
      $scope.stopAutoRefresh(null, 'stop');
    });
    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    //  restart the auto refresh is the chat window is closed
    var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
      $scope.stopAutoRefresh(null, 'start');
    });

    $scope.$on('$destroy', function () {
      if(chatWindowOpenEvent){
        chatWindowOpenEvent();
      }
      if(chatWindowCloseEvent){
        chatWindowCloseEvent();
      }
      $scope.stop();
      currentSelectedRowReqEvent();
      updateRequest();
      if ($scope.tachoDownloadStatusSettings && $scope.tachoDownloadStatusSettings.source) {
        delete $scope.tachoDownloadStatusSettings.source;
      }
      if ($scope.tachoDownloadStatusListAdapter) {
        delete $scope.tachoDownloadStatusListAdapter;
      }
    });

  }).controller('tachoDownloadStatusEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {

    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '20', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.js